import { useTranslation } from "react-i18next";
import { getOperatorsFromAvailableFilters } from "../helpers/helpersSearchs";

const useLicensesFilters = () => {
  const [t] = useTranslation("global");

  const filterNames = {
    licensesStatus: t("licenses.licensesStatus"),
    username: t("Data.table.Username"),
  };

  const filtersList = [
    {
      columnField: "username",
      sortable: false,
    },
    {
      columnField: "licensesStatus",
      sortable: false,
    },
  ];

  const getFilters = () => {
    const filters: any[] = filtersList.map((filter) => {
      if (filter.columnField === "username") {
        return {
          field: filter.columnField,
          headerName: (filterNames as never)[filter.columnField],
          width: 260,
          disableColumnMenu: true,
          sortable: false,
          type: "string",
          filterOperators: getOperatorsFromAvailableFilters([
            "$ilike",
            "$eq",
            "$ne",
          ]),
          filter: "LOCAL",
          service: "text",
          queryFormat: "",
        };
      }

      if (filter.columnField === "licensesStatus") {
        return {
          field: filter.columnField,
          headerName: (filterNames as never)[filter.columnField],
          width: 250,
          disableColumnMenu: true,
          sortable: false,
          type: "string",
          filterOperators: getOperatorsFromAvailableFilters(["$eq", "$ne"]),
          filter: "LOCAL",
          service: "special-licenses",
          queryFormat: "",
        };
      }

      return {
        field: filter.columnField,
        headerName: (filterNames as never)[filter.columnField],
        filterable: true,
        sortable: false,
        disableColumnMenu: true,
        editable: true,
      };
    });

    return filters;
  };

  return { filter: getFilters };
};

export default useLicensesFilters;
